import { SolicitudCamViewModel } from 'src/app/components/_campanias/types/solicitudcam-datosbasicos.types';

export class NavMenuServiceSolicitudCam {
    protected _currentSolicitudCam: SolicitudCamViewModel | undefined = new SolicitudCamViewModel();

    protected refresh(): void {
        // TO BE OVERRIDEN IN THE PARENT
    }

    protected resetSolicitudCamData(): void {
        this._currentSolicitudCam = new SolicitudCamViewModel();
    }

    protected set currentSolicitudCam(value: SolicitudCamViewModel) {
        this._currentSolicitudCam = value;
        this.refresh();
    }

    protected get currentSolicitudCam(): SolicitudCamViewModel {
        if (!this._currentSolicitudCam) {
            this._currentSolicitudCam = new SolicitudCamViewModel();
        }
        return this._currentSolicitudCam;
    }

    public updateMenuServiceForSolicitudCam(id: number, IdEstadoSolicitudCam: number, IdTipoSolicitudCam: number): void {
        const vm = new SolicitudCamViewModel();
        vm.Id = id;
        vm.IdEstadoSolicitudCam = IdEstadoSolicitudCam;
        vm.IdTipoSolicitudCam = IdTipoSolicitudCam;
        this.currentSolicitudCam = vm;
    }

    public clearMenuServiceForSolicitudCam(): void {
        const vm = new SolicitudCamViewModel();
        vm.Id = 0;
        vm.IdEstadoSolicitudCam = 0;
        this.currentSolicitudCam = vm;
    }

    protected get isSolicitudCamSelected(): boolean {
        if (this.currentSolicitudCam && this.currentSolicitudCam.Id) {
            return this.currentSolicitudCam.Id > 0;
        } else return false;
    }
}
